import React from 'react';

import { NetworkError } from 'Components/Errors/NetworkError';
import { useOnlineStatus } from 'Utils/hooks/useOnlineStatus';

const InternetConnection: React.FC = ({ children }) => {
  const { online } = useOnlineStatus();

  if (!online) {
    return <NetworkError />;
  }

  return <>{children}</>;
};

export default InternetConnection;
